import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { OurTeamComponent } from './components/pages/our-team/our-team.component';
import { TestimonialsComponent } from './components/pages/testimonials/testimonials.component';
import { PricingTableComponent } from './components/pages/pricing-table/pricing-table.component';
import { OurFeaturesComponent } from './components/pages/our-features/our-features.component';
import { QuoteComponent } from './components/pages/quote/quote.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { BlogGridComponent } from './components/pages/blog-grid/blog-grid.component';
import { BlogStandardComponent } from './components/pages/blog-standard/blog-standard.component';
import { ContactComponent } from './components/pages/contact/contact.component';

const routes: Routes = [
  {path: '', component: HomeOneComponent},
  {path: 'about-us', component: AboutUsComponent},
  {path: 'our-team', component: OurTeamComponent},
  {path: 'testimonials', component: TestimonialsComponent},
  {path: 'pricing-table', component: PricingTableComponent},
  {path: 'our-features', component: OurFeaturesComponent},
  {path: 'quote', component: QuoteComponent},
  {path: 'coming-soon', component: ComingSoonComponent},
  {path: 'services', component: ServicesComponent},
  {path: 'blog-grid', component: BlogGridComponent},
  {path: 'blog-standard', component: BlogStandardComponent},
  {path: 'contact', component: ContactComponent},
  // Here add new pages component

  {path: '**', component: ErrorComponent} // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
